import Home from '../pages/VideoCallPage/VideoCallApp';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '../contexts/ThemeContext';

function AuthRoutes() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </ThemeProvider>
  )
}
function UnAuthRoutes() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </ThemeProvider>
  )
}


const RouterManager = () => {
      return (
        <>
        { true ? <AuthRoutes /> : <UnAuthRoutes /> }
        </>
      )
}

export default RouterManager;
